/* ==========================================================================
   ARCANE — motion.js
   No dependencies. Everything here degrades to a working, static site
   if the file fails to load.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveals */
  function reveals() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    // Reduced motion, or no observer support: show everything at once.
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* The ticker duplicates its own content in Liquid, not here — the marquee
     keeps looping seamlessly even if this file never loads. */

  /* -------------------------------------------------------------- mobile nav */
  function menu() {
    var sheet = document.querySelector('[data-menu]');
    if (!sheet) return;
    var open = document.querySelector('[data-menu-open]');
    var close = document.querySelector('[data-menu-close]');

    function set(state) {
      sheet.setAttribute('data-open', state);
      document.body.style.overflow = state === 'true' ? 'hidden' : '';
      if (open) open.setAttribute('aria-expanded', state);
    }
    if (open) open.addEventListener('click', function () { set('true'); });
    if (close) close.addEventListener('click', function () { set('false'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.getAttribute('data-open') === 'true') set('false');
    });
  }

  /* -------------------------------------------------------- sticky add-to-cart
     Shown only once the real add-to-cart button has scrolled out of view,
     so the two never compete for the same tap.                            */
  function stickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      bar.setAttribute('data-show', entries[0].isIntersecting ? 'false' : 'true');
    }, { rootMargin: '0px 0px -60px 0px' }).observe(anchor);

    // Tapping the sticky bar submits the real form, so there is one source of truth.
    var btn = bar.querySelector('[data-sticky-submit]');
    if (btn) {
      btn.addEventListener('click', function () {
        var form = document.getElementById('product-form');
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  }

  /* ---------------------------------------------------------- variant picker
     Swaps price, availability and the ?variant= URL without a page load.  */
  function variants() {
    var root = document.querySelector('[data-variant-picker]');
    if (!root) return;

    var data = document.querySelector('[data-variant-json]');
    if (!data) return;

    var list;
    try { list = JSON.parse(data.textContent); } catch (e) { return; }

    var idField = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-variant-price]');
    var submit = document.querySelector('[data-atc-submit]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyBtn = document.querySelector('[data-sticky-submit]');

    function selected() {
      return Array.prototype.map.call(
        root.querySelectorAll('input:checked'),
        function (i) { return i.value; }
      );
    }

    function update() {
      var chosen = selected();
      var match = list.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (stickyPrice) stickyPrice.textContent = match.price_label;

      var label = match.available ? match.add_label : match.sold_label;
      [submit, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !match.available;
        b.textContent = label;
      });

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }

    root.addEventListener('change', update);
  }

  /* --------------------------------------------------------------- bootstrap */
  function init() {
    reveals();
    menu();
    stickyAtc();
    variants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
